import { QESButton } from "@app/shared/qes-standards/Button";
import { FC, useContext } from "react";
import { ReportCustomizationContext } from "../ReportCustomizationContext";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { FontAwesome } from "@app/shared/icons/qesIcons";

interface GenerateSectionProps {
  settingsAreValid?: boolean;
  onGenerate: () => void;
}

export const GenerateSection: FC<GenerateSectionProps> = (props: GenerateSectionProps) => {
  const rcContext = useContext(ReportCustomizationContext);

  return (
    <div className="container-fluid ms-0">
      <div className="row justify-content-end">
        <QESButton
          className="col-auto"
          qesType="primary"
          qesTestId="report-customization__primary"
          onClick={props.onGenerate}
          disabled={rcContext.state.isGenerating || !props.settingsAreValid}
        >
          Generate {rcContext.state.isGenerating && <QesIcon iconName={FontAwesome.Spinner} className="qes-icon-spin" description="Submitting report request" />}
        </QESButton>
      </div>
    </div>
  )
}